import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import {TABLET_BREAKPOINT} from '../utils/constants';

import AboveFold from '../components/common/above-fold/AboveFold';
import DestinationsModule from '../components/multi-destination/destinations/DestinationsModule';
import PopularDestinationsModule from '../components/multi-destination/popular-destinations/PopularDestinationsModule';
import Branding from '../components/multi-destination/branding/Branding';
import SeoSectionModule from '../components/multi-destination/seo-section/SeoSectionModule';
import DateModal from '../components/common/date-modal/DateModal';
import EmailCaptureModule from '../components/multi-destination/email-capture/EmailCaptureModule';
import DynamicSeoLinkpile from '../components/common/seo-linkpile/DynamicSeoLinkpile';
import {AsyncToaster} from '../components/common/toaster/AsyncToaster';
import {TESTS} from '../utils/abacus';
import {pushEdapEvent} from '../utils/edap';
import {AsyncTripBoardModal} from '../components/common/tripboard/AsyncTripBoardModal';
import {fullExposures, withErrorBoundary, withTripboards} from './helpers';

import '../components/multi-destination/styles.less';

export const fullExposureTests = [
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.DISCOVERY_SITE_NAVIGATION,
    TESTS.DISCOVERY_SITE_NAVIGATION_NEW_LABEL,
];

const possiblyProgramaticMlps = ['weekender', 'staycation'];

export class TemplateComponent extends Component {
    componentDidMount() {
        const {themeId, isProgrammatic} = this.props;

        if (possiblyProgramaticMlps.includes(themeId)) {
            const data = {
                eventcategory: isProgrammatic ? 'programmatic' : 'generic',
            };

            pushEdapEvent('pageview', data);
        }

        const {isMobile, hasTouch, dispatch} = this.props;
        dispatch({
            type: 'SET_VIEWPORT',
            payload: {isMobile, hasTouch},
        });
    }

    componentDidUpdate() {
        const {isMobile, hasTouch, dispatch} = this.props;
        dispatch({
            type: 'SET_VIEWPORT',
            payload: {isMobile, hasTouch},
        });
    }

    render() {
        const {branding, showPlaceholders} = this.props;

        const mainCSSClass = classNames('app-main', 'mlp', {
            'container--loading__visible': showPlaceholders,
        });

        return (
            <Fragment>
                <main className={mainCSSClass}>
                    {fullExposures([...fullExposureTests])}
                    <AboveFold />
                    {branding && withErrorBoundary(<Branding />)}
                    {withErrorBoundary(<PopularDestinationsModule />)}
                    {withTripboards(<DestinationsModule />)}
                    {withErrorBoundary(<SeoSectionModule />)}
                    {withErrorBoundary(<EmailCaptureModule />)}
                    {withErrorBoundary(<DynamicSeoLinkpile forceExpanded />)}
                    {withErrorBoundary(<DateModal />)}
                </main>
                {withErrorBoundary(<AsyncToaster />)}
                {withErrorBoundary(<AsyncTripBoardModal />)}
            </Fragment>
        );
    }
}

export function mapStateToProps(state) {
    const {
        modules: {branding},
        config: {themeId, isProgrammatic},
        options,
    } = state;

    return {
        branding,
        isProgrammatic,
        showPlaceholders: options.showPlaceholders,
        themeId,
    };
}

export const Template = connect(mapStateToProps)(
    determineIfMobile(TemplateComponent, TABLET_BREAKPOINT)
);

Template.displayName = 'Template';

export default Template;
